import styled from 'styled-components';

import { basicBodyTextStyle, fonts } from '@dreryk/react-components';

export const StyledPatientAutosuggestItemName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

StyledPatientAutosuggestItemName.displayName = 'StyledPatientAutosuggestItemName';
